export default __webpack_public_path__ + "resources/icons/d231-4a53.webp";